module.exports = __webpack_public_path__ + "img/mcm-coming-soon.68e44aa4.jpg";